module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURUdwTCwsLCoqKi0tLScnJy0tLS0tLSQkJCwsLC0tLSwsLC0tLSoqKi0tLSwsLB4eHi0tLS0tLSwsLC0tLS4uLq7Y5AwAAAAUdFJOUwB3NPIP7MoVSPqGuSTVXwSWZanXEKCbxwAAAHFJREFUGNNd0FsSgCAIBVAs31r2YP9rDayZvPJ5Bi8INZN8JSjDzC4AOSH2QKsS25G8SgpzFmd4aJNQxJGn0IWkaZhFFHSzqW0RW6e+qHvICJsXMN6K/GSrYL1cHfPeOv6Vy0dmGLL3o9xwgbYfJQd6AGBAB4fvWQDFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header/tel.png
// module id = YgbM
// module chunks = 0